var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mb-1 p-0"},[_c('gallery-title')],1)],1),_c('b-row',[_c('b-col',{staticClass:"mb-0"},[(!_vm.idGallery)?_c('gallery-list'):_c('gallery-item')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }